import { render, staticRenderFns } from "./GameStats.vue?vue&type=template&id=22a6b4c6&scoped=true&"
import script from "./GameStats.vue?vue&type=script&lang=ts&"
export * from "./GameStats.vue?vue&type=script&lang=ts&"
import style0 from "./GameStats.vue?vue&type=style&index=0&id=22a6b4c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a6b4c6",
  null
  
)

export default component.exports